/**
 * The plan model's ONE switch: are full Mixpedia and For You free on every
 * plan, or GOAT features?
 *
 *   false → GATED (the launch model, current). Free users see 3 rows per
 *           Mixpedia list behind "See all N results with GOAT", For You is a
 *           GOAT tab, and native auto-presents the paywall once per cold
 *           launch for a free user.
 *   true  → OPEN (the 2026-09-04 experiment). Every gate below no-ops, For You
 *           loses its badge, the upgrade modal leads with Cloud Backup + Set
 *           Planner, and nothing auto-presents on mobile.
 *
 * Flip this constant and nothing else in the app:
 *   - main:     tierCache.requireFeature short-circuits the open keys, which
 *               covers every requireFeatureOrReject / denyOrPass / tier:canAccess
 *               gate in main.js (the djpal:feed* + getMixCompanions handlers).
 *   - renderer: useTierGate reports canAccess for the open keys, which covers
 *               ArtistSearch / TrackSearch / MixSearch slicing + lock buttons and
 *               FeedTab's "Unlock with GOAT" screen. CategoryView, the
 *               GoatUpgradeModal lead benefits and App.js's native launch
 *               paywall read MIXPEDIA_FREE_FOR_ALL directly.
 * The website has its own copy of the switch in
 * mixgoat-website/src/lib/planModel.ts — flip both together and ship the
 * desktop release before (or with) the website push, or the site advertises
 * what the released app still locks.
 *
 * Pure CJS on purpose: main.js requires it and the renderer imports it (like
 * loudnessLimits.js), so both processes always agree.
 */
const MIXPEDIA_FREE_FOR_ALL = false;

// The feature keys (tierService / tierSlice GOAT_FEATURES) the switch opens.
const OPEN_WHEN_FREE_FOR_ALL = ['full-mixpedia', 'feed'];

/**
 * True when `featureKey` is free on every plan under the current model. The
 * second argument exists for tests; callers never pass it.
 */
function isFreeOnEveryPlan(featureKey, freeForAll = MIXPEDIA_FREE_FOR_ALL) {
    return !!freeForAll && OPEN_WHEN_FREE_FOR_ALL.includes(featureKey);
}

module.exports = {
    MIXPEDIA_FREE_FOR_ALL,
    OPEN_WHEN_FREE_FOR_ALL,
    isFreeOnEveryPlan,
};
